var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGec2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5003 0.916748C7.45033 0.916748 0.916992 7.45008 0.916992 15.5001C0.916992 23.5501 7.45033 30.0834 15.5003 30.0834C23.5503 30.0834 30.0837 23.5501 30.0837 15.5001C30.0837 7.45008 23.5503 0.916748 15.5003 0.916748ZM11.5482 21.7563L6.31282 16.5209C6.17781 16.3859 6.07071 16.2256 5.99764 16.0492C5.92457 15.8728 5.88696 15.6837 5.88696 15.4928C5.88696 15.3018 5.92457 15.1128 5.99764 14.9364C6.07071 14.76 6.17781 14.5997 6.31282 14.4647C6.44784 14.3296 6.60813 14.2225 6.78453 14.1495C6.96094 14.0764 7.15001 14.0388 7.34095 14.0388C7.53189 14.0388 7.72096 14.0764 7.89737 14.1495C8.07377 14.2225 8.23406 14.3296 8.36908 14.4647L12.5837 18.6647L22.617 8.63133C22.8897 8.35866 23.2595 8.20547 23.6451 8.20547C24.0307 8.20547 24.4006 8.35866 24.6732 8.63133C24.9459 8.90401 25.0991 9.27383 25.0991 9.65946C25.0991 10.0451 24.9459 10.4149 24.6732 10.6876L13.6045 21.7563C13.4696 21.8915 13.3093 21.9988 13.1329 22.072C12.9565 22.1451 12.7674 22.1828 12.5764 22.1828C12.3854 22.1828 12.1963 22.1451 12.0198 22.072C11.8434 21.9988 11.6832 21.8915 11.5482 21.7563Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGec2);
export default __webpack_public_path__ + "static/media/gec2.75c7f44c33275d2ee931e495fc26ac40.svg";
export { ForwardRef as ReactComponent };